module.exports = __webpack_public_path__ + "img/紫竹创业孵化器有限公司科创之星.9527c213.png";